import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Box, Tabs, Tab } from '@material-ui/core';
import { useStyles } from '../styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Store } from '../Store';
import MainFooter from '../components/MainFooter';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';


const Favourites = () => {
  const { state } = useContext(Store);
  const styles = useStyles();
  const history = useHistory();
  const [tabSel, setTabSel] = React.useState(2);

  let { setting } = state.userSetting;
  if(!setting){
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }

  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }

  const goto = (subpath) => {
    history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }

  return (
    <Box
      className={styles.root}
      style={{ padding: "0px!important", backgroundColor: setting.themeColor }}
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 1 }}>
        <ArrowBackIosNewIcon 
          style={{color: setting.themeTxtColor}} 
          onClick={() => history.goBack()}
        />
        <Typography variant="h6" style={{ color: setting.themeTxtColor }}>
          Favourites
        </Typography>
        <Box style={{width: "24px"}} /> {/* Spacer for alignment */}
      </Box>

      <Box style={{ 
        padding: "20px", 
        minHeight: "calc(100vh - 180px)",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Typography 
          variant="h5" 
          style={{ 
            color: setting.themeTxtColor,
            textAlign: 'center',
            fontWeight: 500
          }}
        >
          Coming Soon!
        </Typography>
        <Typography 
          variant="body1" 
          style={{ 
            color: setting.themeTxtColor,
            textAlign: 'center',
            marginTop: '10px',
            opacity: 0.8
          }}
        >
          We're working on bringing you the best favorites experience.
        </Typography>
      </Box>

      <MainFooter tabSel={2} />
    </Box>
  );
};

export default Favourites;
